export const COUNTRY_AND_PROVINCES = {
  COUNTRY_AND_PROVINCES_SET_SELECTED: "COUNTRY_AND_PROVINCES_SET_SELECTED",
  COUNTRY_AND_PROVINCES_CLEAR_SELECTED: "COUNTRY_AND_PROVINCES_CLEAR_SELECTED",
};
